module.exports = __webpack_public_path__ + "img/1.1a1390b8.jpg";